import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferDismissed = ({ offerKey }: Params) =>
  track({ event: "offer_dismissed", ...buildOfferAnalyticsBaseParams(offerKey) });
